import React, { useCallback, useEffect, useState } from "react";
import api, { BULAN, fileUrl, formatRupiah , formatTanggal} from "@/lib/api";
import Layout, { PageTitle } from "@/components/Layout";
import { NAV_KEPSEK } from "@/lib/nav";
import { FilterBar } from "@/components/FilterBar";
import BackupExcelButton from "@/components/BackupExcelButton";
import { FileText } from "lucide-react";

const F_EMPTY = { q: "", bulan: "", tahun: "" };

export function ListGaji() {
  const [all, setAll] = useState([]);
  const [filters, setFilters] = useState(F_EMPTY);
  const [applied, setApplied] = useState(F_EMPTY);

  const load = useCallback(async () => { try { const { data } = await api.get("/gaji"); setAll(data); } catch (e) { console.error(e); } }, []);
  useEffect(() => { load(); }, [load]);

  const items = all.filter((it) => {
    if (applied.q && !(it.nama_guru || "").toLowerCase().includes(applied.q.toLowerCase())) return false;
    if (applied.bulan && it.bulan !== applied.bulan) return false;
    if (applied.tahun && String(it.tahun) !== String(applied.tahun)) return false;
    return true;
  });

  return (
    <Layout nav={NAV_KEPSEK}>
      <PageTitle title="Daftar Gaji Guru" action={<BackupExcelButton endpoint="gaji" filters={applied} testId="backup-gaji-btn" />} />
      <FilterBar
        filters={filters} setFilters={setFilters}
        onApply={() => setApplied({ ...filters })}
        onReset={() => { setFilters(F_EMPTY); setApplied(F_EMPTY); }}
        dataTestidPrefix="gaji-filter"
        fields={[
          { key: "q", type: "text", label: "Nama Guru", placeholder: "Cari nama guru" },
          { key: "bulan", type: "bulan", label: "Bulan" },
          { key: "tahun", type: "tahun", label: "Tahun" },
        ]}
      />
      <section className="pp-card pp-freeze overflow-hidden">
        <table className="w-full text-sm">
          <thead><tr className="pp-table-header">
            <th className="text-left px-5 py-3">Nama Guru</th>
            <th className="text-left px-5 py-3">Bulan/Tahun</th>
            <th className="text-right px-5 py-3">Jumlah</th>
            <th className="text-left px-5 py-3">Tgl Bayar</th>
            <th className="text-left px-5 py-3">Slip</th>
          </tr></thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={5} className="text-center py-10 text-slate-400 italic">Belum ada data.</td></tr>}
            {items.map((it) => (
              <tr key={it.id} className="pp-row">
                <td className="px-5 py-3 font-medium">{it.nama_guru}</td>
                <td className="px-5 py-3">{BULAN.find((b) => b.v === it.bulan)?.label} {it.tahun}</td>
                <td className="px-5 py-3 text-right font-mono">{formatRupiah(it.jumlah)}</td>
                <td className="px-5 py-3 text-slate-600">{formatTanggal(it.tanggal_bayar)}</td>
                <td className="px-5 py-3">{it.slip_file_id ? <a href={fileUrl(it.slip_file_id)} target="_blank" rel="noreferrer" className="text-indigo-600 inline-flex items-center gap-1 text-xs"><FileText className="w-3.5 h-3.5" />Lihat</a> : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
    </Layout>
  );
}
